import React, { useEffect, useState, useCallback } from "react";
import swal from "sweetalert";
import { getPayableListing } from "../../../Bookclosure/Services/ApiHandler";
import Pagination from "./Pagination";
import styles from "./Table.module.css";

const PayableTable = ({ PayableID, filters = [], onNoDataFound })  => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalPages, setTotalPages] = useState(1);

    const formatHeading = (text) =>
       text
         .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
         .replace(/([a-z])([A-Z])/g, "$1 $2")
         .trim();
   
     const loadData = useCallback(async () => {
       try {
         const response = await getPayableListing(PayableID, {
           page: currentPage,
           pageSize: rowsPerPage,
           filters: filters,
         });
   
         const res = response.data;
   
         const newListing = res.payableListing || [];
         const fetchedData = res.payableListing || [];
         setColumns(res.payableListingHeaders || []);
         setData(fetchedData);
         
         // If backend returns more data than requested, it means pagination is broken on backend
         if (fetchedData.length > rowsPerPage || res.totalPages === 1) {
            setTotalPages(Math.ceil(fetchedData.length / rowsPerPage) || 1);
         } else {
            setTotalPages(res.totalPages || 1);
         }

         if (filters && filters.length > 0 && newListing.length === 0) {
            const contentDiv = document.createElement("div");
            contentDiv.innerHTML = "<div style='text-align: center;'>Please check if you entered the correct values for the selected filter.</div>";
            swal({
              title: "No Data Found",
              content: contentDiv,
              icon: "info",
            }).then(() => {
              if (typeof onNoDataFound === "function") {
                onNoDataFound();
              }
            });
         }
       } catch (error) {
         console.error("Error loading data:", error);
       }
     }, [PayableID, currentPage, rowsPerPage, filters]);
   
     useEffect(() => {
       loadData();
     }, [loadData]); 
   
  return (
    <div className={styles.wrapper}>
     <div className={styles.tableContainer}>
       <table className={styles.table}>
         <thead>
           <tr>
             {columns.map((col) => (
              <th key={col}>{formatHeading(col)}</th>
             ))}
           </tr>
         </thead>
        
         <tbody>
           {(data.length > rowsPerPage 
               ? data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage) 
               : data
            ).map((row, i) => (
            <tr key={i}>
              {columns.map((col) => (
                <td key={col}>{row[col] ?? "-"}</td>
              ))}
            </tr>
           ))}
         </tbody>
       </table>
     </div>

      <div className={styles.paginationWrapper}>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(rows) => {
            setRowsPerPage(rows);
            setCurrentPage(1);
          }}
        />
      </div>
    </div>
  );
}

export default PayableTable;